import { render } from "./IndexDemande.vue?vue&type=template&id=2dbe2378"
import script from "./IndexDemande.vue?vue&type=script&lang=js"
export * from "./IndexDemande.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__